import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * Store for the reservations "How it works" modal. Open from sidebar info button or from the reservations page.
 */
export const useReservationsHowItWorksStore = defineStore('reservationsHowItWorks', () => {
  const open = ref(false)

  function show() {
    open.value = true
  }

  function close() {
    open.value = false
  }

  return {
    open,
    show,
    close,
  }
})
